import React from 'react';
import TokenList from './components/TokenList';
import PartnerList from './components/PartnerList';
import EditMessageTemplate from './components/EditMessageTemplate';
import EmailQueueList from './components/EmailQueueList';
import MailSettings from './components/MailSettings';
export interface AppMenuItem {
  id: string;
  path: string;
  labelKey: string;
  titleKey: string;
  icon?: string;
  roles?: string[]; // empty or undefined => public
  content?: JSX.Element;
}

export const APP_MENU: AppMenuItem[] = [
  {
    id: 'partners',
    path: '/partners',
    labelKey: 'menu.partners',
    titleKey: 'partnerList.title',
    icon: 'pi pi-fw pi-users',
    content: <PartnerList />
  },
  {
    id: 'tokens',
    path: '/tokens',
    labelKey: 'menu.tokens',
    titleKey: 'tokenList.title',
    icon: 'pi pi-fw pi-key',
    roles: [],
    content: <TokenList />
  },
  {
    id: 'messageTemplates',
    path: '/message-templates',
    labelKey: 'menu.messageTemplates',
    titleKey: 'messageTemplate.edit',
    icon: 'pi pi-fw pi-envelope',
    roles: ['admin'],
    content: <EditMessageTemplate />
  },
  {
    id: 'emailQueue',
    path: '/email-queue',
    labelKey: 'menu.emailQueue',
    titleKey: 'emailQueue.title',
    icon: 'pi pi-fw pi-send',
    roles: ['admin'],
    content: <EmailQueueList />
  },
  {
    id: 'mailSettings',
    path: '/mail-settings',
    labelKey: 'menu.mailSettings',
    titleKey: 'mailSettings.title',
    icon: 'pi pi-fw pi-cog',
    roles: ['admin'],
    content: <MailSettings />
  }
];
